import { css } from 'glamor'
import * as React from 'react'
import * as PropTypes from 'prop-types'
import moment from 'moment'
import { FormattedMessage, defineMessages, FormattedDate } from 'react-intl'

import { Button, ButtonVariant, ButtonSize } from '../button'
import { Flex } from '../flex'
import { Popup } from '../popup'

import { Datepicker } from './datepicker'
import { Theme } from '../../theme'

const messages = defineMessages({
  createdAtButton: {
    id: 'ui-kit.date-dropdown.any-date',
    defaultMessage: 'Any date',
  },
})

interface IDateDropdownProps {
  value?: string
  onChange: (value: moment.Moment) => void
  firstSelectableDate?: moment.Moment
  lastSelectableDate?: moment.Moment
  buttonVariant?: ButtonVariant
  buttonSize?: ButtonSize
}

export class DateDropdown extends React.Component<IDateDropdownProps> {
  static propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    buttonVariant: PropTypes.oneOf(Button.VARIANTS),
    buttonSize: PropTypes.oneOf(Button.SIZES),
    children: PropTypes.node,
    firstSelectableDate: PropTypes.object,
    lastSelectableDate: PropTypes.object,
  }

  onChange = (cb: () => void, toDate: moment.Moment) => {
    this.props.onChange(toDate)
    cb()
  }

  getLabel() {
    const { value, children } = this.props
    if (value) {
      return <FormattedDate value={value} />
    }
    if (children) {
      return children
    }
    return <FormattedMessage {...messages.createdAtButton} />
  }
  static BUTTON_VARIANTS = Button.VARIANTS

  render() {
    const { value, firstSelectableDate, lastSelectableDate, buttonVariant = 'clear', buttonSize } = this.props

    return (
      <div {...css({ display: 'inline-flex' })}>
        <Popup
          renderPopup={({ toggleOpen }) => (
            <Theme>
              {theme => (
                <Flex>
                  <Datepicker
                    firstSelectableDate={firstSelectableDate}
                    lastSelectableDate={lastSelectableDate}
                    onChange={val => this.onChange(toggleOpen, val)}
                    style={{
                      marginLeft: theme.settings.spacing.large,
                      marginRight: theme.settings.spacing.large,
                      marginTop: theme.settings.spacing.large,
                    }}
                    value={value}
                  />
                </Flex>
              )}
            </Theme>
          )}
          renderToggle={({ toggleOpen, ref }) => (
            <Button
              direction="down"
              flush
              innerRef={ref}
              multiChoice
              onClick={toggleOpen}
              size={buttonSize}
              style={{ display: 'inline-flex' }}
              variant={buttonVariant}
            >
              {this.getLabel()}
            </Button>
          )}
        />
      </div>
    )
  }
}
